import React from 'react';
import { useSessionContext } from './SessionContext';
import { ATTRIBUTE_OPTIONS } from './utils';

/* Ticks near the ends cannot be centred on their own position without hanging off the bar --
 * the 1/yr tick sits at 0.963, twelve pixels from the end at desktop width. Anchor those to
 * the edge instead of centring them, so the label stays inside the bar and the tick mark
 * still shows where the value actually is.
 */
const EDGE = 0.06;

function tickLabelStyle(position) {
  if (position < EDGE) return { left: 0 };
  if (position > 1 - EDGE) return { right: 0 };
  return { left: `${position * 100}%`, transform: 'translateX(-50%)' };
}

export default function Legend() {
  const { selectedAttribute } = useSessionContext();
  const attribute = ATTRIBUTE_OPTIONS[selectedAttribute];
  const colorStops = Array.from({ length: 10 }, (_, i) => i / 9)
    .map((value) => `${attribute.colorMapInterpolator(value)} ${(value * 100).toFixed(0)}%`)
    .join(', ');
  const ticks = attribute.scaleTicks || [];
  const caption = attribute.scaleCaption || [];

  return (
    <div style={{ fontSize: '14px', fontWeight: 'bold', paddingBottom: '4px' }}>
      <div
        className="split-spans"
        style={{ margin: '0 4px 2px' }}
      >
        <span>{attribute.rangeValues[0]}</span>
        <span>{attribute.rangeTitle}</span>
        <span>{attribute.rangeValues[1]}</span>
      </div>
      <div
        className="legend-gradient"
        style={{ background: `linear-gradient(to right, ${colorStops})` }}
      />
      {ticks.length > 0 && (
        <div className="legend-ticks">
          {ticks.map((tick) => (
            <span
              key={tick.wli}
              className="legend-tick-mark"
              style={{ left: `${tick.position * 100}%` }}
            />
          ))}
          {ticks.map((tick) => (
            <span
              key={tick.wli}
              className="legend-tick-label"
              style={tickLabelStyle(tick.position)}
              title={tick.title}
            >
              {tick.label}
            </span>
          ))}
        </div>
      )}
      <div className="split-spans" style={{ margin: '2px 4px' }}>
        <span>{attribute.rangeLabels[0]}</span>
        <span>{attribute.rangeLabels[1]}</span>
      </div>
      {caption.length > 0 && (
        <div className="legend-caption" title={attribute.scaleCaptionTitle}>
          {caption.map((line) => <div key={line}>{line}</div>)}
        </div>
      )}
    </div>
  );
}
